import React from "react";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function showSuccessMessage(message) {
  toast(
    <>
      <FontAwesomeIcon icon="check-circle" />
      <span className="text">{message}</span>
    </>,
    {
      position: "bottom-right",
      autoClose: 12000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      bodyClassName: "cob-toast-body",
      className: "cob-toast",
    }
  );
}
